
import serverUrl from './env'
var apiUrl = serverUrl + "/admin/"
let servicePath = {
    serverUrl: serverUrl,
    apiUrl: apiUrl,
    checkLogin: apiUrl + 'checkLogin',  //检查用户名密码
    cameraList: apiUrl + 'cameraList',//获取所以摄像头
    getCameraInfo: apiUrl + 'getCameraInfo',//获取单个摄像头
    editCameraInfo: apiUrl + 'editCameraInfo',//修改摄像头信息
    crawlSingleCamera: apiUrl + 'crawlSingleCamera',//手动刷新单个摄像头预报
    addCameraInfo: apiUrl + 'addCameraInfo',//添加摄像头信息
    getCategoriesList: apiUrl + 'getCategoryList',// 查询城市分类列表

    // 广告
    getAdlList: apiUrl + 'getAdList',//广告列表
    addAdInfo: apiUrl + 'addAdInfo',//添加广告内容
    editAdInfo: apiUrl + 'editAdInfo',//修改广告信息
    deleteAdInfo: apiUrl + 'deleteAdInfo',//删除单个广告信息
    getAdInfo: apiUrl + 'getAdInfo',//获取单个广告信息

    getBannerList : apiUrl + 'getBannerList',
    getBannerInfo : apiUrl + 'getBannerInfo',
    addBanner : apiUrl + 'addBanner',
    editBanner : apiUrl + 'editBanner',
    deleteBanner : apiUrl + 'deleteBanner',

    // 知识天地文章
    getNewsList: apiUrl + 'getNewsList',//知识天地文章列表
    getNewsType: apiUrl + 'getNewsType',//知识天地文章分类
    addNewsInfo: apiUrl + 'addNewsInfo',//添加知识天地文章内容
    editNewsInfo: apiUrl + 'editNewsInfo',//修改知识天地文章信息
    deleteNewsInfo: apiUrl + 'deleteNewsInfo',//删除单个知识天地文章信息
    getNewsInfo: apiUrl + 'getNewsInfo',//获取单个知识天地文章信息

    // 公告
    getMiniProgramInfo: apiUrl + 'getMiniProgramInfo',//获取小程序详情内容
    editMiniProgramInfo: apiUrl + 'editMiniProgramInfo',//修过信息信息

    getNoticelList: apiUrl + 'getNoticeList',//公告列表
    addNoticeInfo: apiUrl + 'addNoticeInfo',//添加公告内容
    editNoticeInfo: apiUrl + 'editNoticeInfo',//修改公告信息
    deleteNoticeInfo: apiUrl + 'deleteNoticeInfo',//删除单个公告信息
    getNoticeInfo: apiUrl + 'getNoticeInfo',//获取单个公告信息

    queryIdleList: apiUrl + 'queryIdleList',//闲置列表
    deleteIdle: apiUrl + 'deleteIdle',//闲置列表
    queryCarpoolList: apiUrl + 'queryCarpoolList',//拼车列表
    deleteCarpool: apiUrl + 'deleteCarpool',//拼车列表
    getFeedbackList: apiUrl + 'getFeedbackList',//反馈内容列表
    editFeedbackState: apiUrl + 'editFeedbackState',//修改反馈查看状态
    replyFeedback: apiUrl + 'replyFeedback',//管理员回复反馈
    uploadReplyImg: apiUrl + 'uploadReplyImg',//上传回复图片
    getUserList: apiUrl + 'getUserList',//用户列表
    giftVipMembership: apiUrl + 'giftVipMembership',//赠予会员
    cancelGiftVipMembership: apiUrl + 'cancelGiftVipMembership',//取消赠与
    getUserVipGiftLog: apiUrl + 'getUserVipGiftLog',//获取用户赠予日志
    getUserPayOrders: apiUrl + 'getUserPayOrders',//获取用户充值/支付记录

    // 浪点地理分类
    getSurfSpotGeoList: apiUrl + 'getSurfSpotGeoList',//浪点地理列表
    getSurfSpotGeoInfo: apiUrl + 'getSurfSpotGeoInfo',//获取单个浪点地理信息
    addSurfSpotGeo: apiUrl + 'addSurfSpotGeo',//添加浪点地理
    editSurfSpotGeo: apiUrl + 'editSurfSpotGeo',//修改浪点地理信息
    deleteSurfSpotGeo: apiUrl + 'deleteSurfSpotGeo',//删除单个浪点地理信息

    getTypeInfo: apiUrl + 'getTypeInfo',  //获取文章类别
    addArticle: apiUrl + 'addArticle',  //  添加文章
    updateArticle: apiUrl + 'updateArticle',  //  修改文章
    getArticleList: apiUrl + 'getArticleList',  //  文章列表 
    delArticle: apiUrl + 'delArticle',  //  删除文章 
    getArticleById: apiUrl + 'getArticleById',  //  根据ID获得文章详情 
    // 添加以下API路径

}

export default servicePath